<div class="div-notification-container" *ngFor="let not of notifications; let i = index">
  <div class="div-notification {{ not.className }} {{ not.animation }}" (click)="closeNotification(i)">
    <div class="div-img">
      <img alt="{{ not.image }}" src="{{ not.image }}">
    </div>
    <div class="div-text">
      <h1>{{ not.title | translatePipe }}</h1>
      <p>{{ not.message | translatePipe }}</p>
    </div>
  </div>
</div>
